var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"small content"},[_c('span',{class:`flag-icon flag-icon-${_vm.countryCode.toLowerCase()}`,staticStyle:{"margin-right":"4px"}}),_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }